// extracted by mini-css-extract-plugin
export default {"layoutViewport":"app_layoutViewport__SHP0U"};